// El frontend ya NO se conecta directamente a Supabase Storage.
// Toda subida/eliminación pasa por el backend Node (/api/upload).

const BASE = process.env.REACT_APP_API_URL;

// URL base de Supabase para construir las transformaciones
// Debe coincidir con tu SUPABASE_URL del backend
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;

function getToken() {
  return localStorage.getItem("token");
}

// ── Transformación de imágenes ────────────────────────────────────
// Convierte una URL pública de Supabase Storage al endpoint de
// transformación para servir imágenes comprimidas y redimensionadas.
//
// Uso:
//   getImageUrl(url)                  → width=800, quality=80 (default)
//   getImageUrl(url, 400, 70)         → thumbnail pequeño
//   getImageUrl(url, 1400, 80)        → carrusel hero
//
// Si la URL no es de Supabase (ej: Unsplash), la devuelve sin cambios.
export function getImageUrl(url, width = 800, quality = 80) {
  if (!url) return "";

  // Solo transformar URLs de Supabase Storage
  if (!url.includes("supabase.co/storage")) return url;

  // Convertir de:
  //   .../object/public/assets/Images/foto.jpg
  // A:
  //   .../render/image/public/assets/Images/foto.jpg?width=800&quality=80
  try {
    const transformed = url.replace(
      "/storage/v1/object/public/",
      "/storage/v1/render/image/public/"
    );
    return `${transformed}?width=${width}&quality=${quality}&resize=contain`;
  } catch {
    return url; // fallback a la URL original si algo falla
  }
}

// Presets listos para usar en los componentes
export const imgUrl = {
  hero:      (url) => getImageUrl(url, 1400, 80), // carrusel home
  card:      (url) => getImageUrl(url, 600,  75), // thumbnails de clases/artículos
  thumbnail: (url) => getImageUrl(url, 400,  70), // thumbnails pequeños (admin list)
  editor:    (url) => getImageUrl(url, 1000, 80), // imágenes dentro del editor
  original:  (url) => url,                        // sin transformación (PDFs, etc.)
};

// ── Subir archivo al backend ──────────────────────────────────────
export async function uploadFile(file, folder = "images") {
  const formData = new FormData();
  formData.append("file", file);

  const res = await fetch(`${BASE}/upload?folder=${folder}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    body: formData,
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Error subiendo archivo");
  return data.url;
}

// ── Eliminar archivo ──────────────────────────────────────────────
export async function deleteFile(url) {
  if (!url) return;
  try {
    await fetch(`${BASE}/upload`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify({ url }),
    });
  } catch (err) {
    console.warn("No se pudo eliminar el archivo:", err.message);
  }
}

// ── Límites y tipos aceptados ─────────────────────────────────────
export const ACCEPT = {
  images:    "image/jpeg,image/png,image/webp,image/gif,image/avif",
  pdfs:      "application/pdf",
  resources: "application/pdf,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
};

export const MAX_SIZE = {
  images:    5  * 1024 * 1024,
  pdfs:      20 * 1024 * 1024,
  resources: 50 * 1024 * 1024,
};

export const SIZE_LABEL = {
  images:    "5 MB",
  pdfs:      "20 MB",
  resources: "50 MB",
};